/*
 * Scenario: abort-mid-review
 *
 * Fuenf Rewrites mit grossen Delays zwischen den Emits, sodass der User
 * mittendrin Zeit hat, X zu druecken (oder transport.abort() im Test). Die
 * bereits akzeptierten Vorschlaege bleiben angewendet — _cancelRemaining
 * markiert nur die noch PENDING als rejected.
 *
 * Im Browser: A auf den ersten 1-2 Vorschlaegen druecken, dann X. Erwartung:
 * angewendete Aenderungen bleiben im Text, der Rest ist verworfen, Console
 * meldet "Review cancelled — N accepted, M rejected".
 */

import { emit, wait } from './_helpers.js'

export const name = 'abort-mid-review'
export const description = 'Five rewrites with delays — designed for mid-review abort (X).'

const REWRITES = [
    'Polished a touch — same intent, sharper line.',
    'Cleaner phrasing for the same beat.',
    'Same content, more rhythm.',
    'Trimmed a bit; less abstract.',
    'Final tighten — the shape stays.'
]

export async function run(state) {
    await emit(state, 'session', { sessionId: 'mock-abort-mid' }, 0)
    await emit(state, 'thinking', { text: 'I have five small tweaks — accept the ones you like, X the rest.' }, 250)
    await emit(state, 'thinkingDone', {}, 200)

    const paras = state.context?.cursorContext?.textParagraphs || []
    if (paras.length === 0) {
        await emit(state, 'delta', { text: 'No text paragraphs available.' }, 100)
        await emit(state, 'done', { usage: {} }, 100)
        return
    }

    const count = Math.min(REWRITES.length, paras.length)
    const toolCallIds = []
    for (let i = 0; i < count; i++) {
        const p = paras[i]
        const toolCallId = `tu_amr_${i}_${Date.now().toString(36)}`
        toolCallIds.push(toolCallId)
        await emit(state, 'proposeRewrite', {
            toolCallId,
            paragraphId: p.id,
            baseVersion: typeof p.version === 'number' ? p.version : undefined,
            originalText: p.text,
            newText: REWRITES[i],
            reason: 'Small wording polish.'
        }, 350)
    }
    await emit(state, 'done', { usage: {} }, 200)

    try {
        const results = await Promise.all(toolCallIds.map(id => wait(state, id, 5 * 60 * 1000)))
        const applied = results.filter(r => r.result === 'applied').length
        const rejected = results.length - applied
        await emit(state, 'delta', { text: `Done. ${applied} applied, ${rejected} skipped.` }, 250)
        await emit(state, 'done', { usage: {} }, 100)
    } catch { /* abort: still */ }
}
